import * as React from "react";
import { Box, Chip, Modal, Tab, Tabs, Typography } from "@mui/material";
import { useDataContext } from "../../context/DataContext";
import DetalhadoTable from "./DetalhadoTable";

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "65%",
  bgcolor: "#ffffff",
  border: "solid 6px darkgray",
  borderRadius: "8px",
  p: 4,
  outline: "unset !important",
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index} style={{ height: "90%" }}>
      {value === index && <Box sx={{ p: 3, height: "75%" }}>{children}</Box>}
    </div>
  );
}

interface ModalProps {
  open: boolean;
  onClose: () => void;
  hospital: string;
  especialidade: string;
}

const DetalhadoModal: React.FC<ModalProps> = ({
  open,
  onClose,
  hospital,
  especialidade,
}) => {
  const { detalhado } = useDataContext();
  const [value, setValue] = React.useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  interface Item {
    id: number;
    i_desc_local_passagem: string;
    i_desc_local_passagem_completa: string;
    i_num_passagem: string;
    i_class_risco: string;
    i_data_hora_entrada: string;
    i_data_hora_reg_prim_atend: string | null;
    i_data_hora_triagem: string;
    i_data_hora_saida: string | null;
    i_motivo_saida: string | null;
    data_extracao: string;
  }

  const detalhadoHospital = detalhado[hospital] || {};
  const detalhadoHospitalEspecialidade = detalhadoHospital[especialidade] || {};

  const filtrarPorClassificacaoRisco = (risco: string) => {
    return Object.values(detalhadoHospitalEspecialidade).filter(
      (item) => (item as Item).i_class_risco === risco
    );
  };

  const vermelho = filtrarPorClassificacaoRisco("01 - Vermelho");
  const laranja = filtrarPorClassificacaoRisco("02 - Laranja");
  const amarelo = filtrarPorClassificacaoRisco("03 - Amarelo");
  const verde = filtrarPorClassificacaoRisco("04 - Verde");
  const azul = filtrarPorClassificacaoRisco("05 - Azul");

  const cores = {
    vermelho: "#DE1E1F",
    laranja: "#E96F19",
    amarelo: "#ffce24",
    verde: "#077d04",
    azul: "#007bff",
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={boxStyle}>
        <Typography align="center" variant="h5">
          {hospital} - {especialidade}
        </Typography>

        <Typography align="center" variant="h6" mb={4}>
          Pacientes aguardando atendimento (agora)
        </Typography>

        <Typography align="center" sx={{ mb: 2 }}>
          Classificação de Risco:
        </Typography>

        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          sx={{
            "& .MuiTab-root": {
              // color: 'gray', // Cor do texto das tabs
            },
            "& .Mui-selected": {
              // color: "white", // Cor do texto da tab selecionada
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "transparent", // Cor do indicador de seleção (a linha abaixo da tab)
            },
          }}
        >
          <Tab
            label={
              <span>
                Vermelho{" "}
                <Chip
                  label={vermelho.length}
                  size="small"
                  style={{
                    marginLeft: 8,
                    color: value === 0 ? cores.vermelho : "white",
                    backgroundColor: value === 0 ? "white" : cores.vermelho,
                  }}
                />
              </span>
            }
            sx={{
              color: value === 0 ? "white !important" : cores.vermelho,
              backgroundColor: value === 0 ? cores.vermelho : "transparent",
            }}
          />
          <Tab
            label={
              <span>
                Laranja{" "}
                <Chip
                  label={laranja.length}
                  size="small"
                  style={{
                    marginLeft: 8,
                    color: value === 1 ? cores.laranja : "white",
                    backgroundColor: value === 1 ? "white" : cores.laranja,
                  }}
                />
              </span>
            }
            sx={{
              color: value === 1 ? "white !important" : cores.laranja,
              backgroundColor: value === 1 ? cores.laranja : "transparent",
            }}
          />
          <Tab
            label={
              <span>
                Amarelo{" "}
                <Chip
                  label={amarelo.length}
                  size="small"
                  style={{
                    marginLeft: 8,
                    color: value === 2 ? cores.amarelo : "white",
                    backgroundColor: value === 2 ? "white" : cores.amarelo,
                  }}
                />
              </span>
            }
            sx={{
              color: value === 2 ? "white !important" : cores.amarelo,
              backgroundColor: value === 2 ? cores.amarelo : "transparent",
            }}
          />
          <Tab
            label={
              <span>
                Verde{" "}
                <Chip
                  label={verde.length}
                  size="small"
                  style={{
                    marginLeft: 8,
                    color: value === 3 ? cores.verde : "white",
                    backgroundColor: value === 3 ? "white" : cores.verde,
                  }}
                />
              </span>
            }
            sx={{
              color: value === 3 ? "white !important" : cores.verde,
              backgroundColor: value === 3 ? cores.verde : "transparent",
            }}
          />
          <Tab
            label={
              <span>
                Azul{" "}
                <Chip
                  label={azul.length}
                  size="small"
                  style={{
                    marginLeft: 8,
                    color: value === 4 ? cores.azul : "white",
                    backgroundColor: value === 4 ? "white" : cores.azul,
                  }}
                />
              </span>
            }
            sx={{
              color: value === 4 ? "white !important" : cores.azul,
              backgroundColor: value === 4 ? cores.azul : "transparent",
            }}
          />
        </Tabs>

        <TabPanel value={value} index={0}>
          <DetalhadoTable color={cores.vermelho} rows={vermelho} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DetalhadoTable color={cores.laranja} rows={laranja} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <DetalhadoTable color={cores.amarelo} rows={amarelo} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <DetalhadoTable color={cores.verde} rows={verde} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <DetalhadoTable color={cores.azul} rows={azul} />
        </TabPanel>
      </Box>
    </Modal>
  );
};

export default DetalhadoModal;
